function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import MathUtil from '../math/MathUtil';
import Envelope from '../geom/Envelope';
var Distance = /*#__PURE__*/function () {
  function Distance() {
    _classCallCheck(this, Distance);
    Distance.constructor_.apply(this, arguments);
  }
  return _createClass(Distance, [{
    key: "getClass",
    value: function getClass() {
      return Distance;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "segmentToSegment",
    value: function segmentToSegment(A, B, C, D) {
      if (A.equals(B)) return Distance.pointToSegment(A, C, D);
      if (C.equals(D)) return Distance.pointToSegment(D, A, B);
      var noIntersection = false;
      if (!Envelope.intersects(A, B, C, D)) {
        noIntersection = true;
      } else {
        var denom = (B.x - A.x) * (D.y - C.y) - (B.y - A.y) * (D.x - C.x);
        if (denom === 0) {
          noIntersection = true;
        } else {
          var r_num = (A.y - C.y) * (D.x - C.x) - (A.x - C.x) * (D.y - C.y);
          var s_num = (A.y - C.y) * (B.x - A.x) - (A.x - C.x) * (B.y - A.y);
          var s = s_num / denom;
          var r = r_num / denom;
          if (r < 0 || r > 1 || s < 0 || s > 1) {
            noIntersection = true;
          }
        }
      }
      if (noIntersection) {
        return MathUtil.min(Distance.pointToSegment(A, C, D), Distance.pointToSegment(B, C, D), Distance.pointToSegment(C, A, B), Distance.pointToSegment(D, A, B));
      }
      return 0.0;
    }
  }, {
    key: "pointToSegment",
    value: function pointToSegment(p, A, B) {
      if (A.x === B.x && A.y === B.y) return p.distance(A);
      var len2 = (B.x - A.x) * (B.x - A.x) + (B.y - A.y) * (B.y - A.y);
      var r = ((p.x - A.x) * (B.x - A.x) + (p.y - A.y) * (B.y - A.y)) / len2;
      if (r <= 0.0) return p.distance(A);
      if (r >= 1.0) return p.distance(B);
      var s = ((A.y - p.y) * (B.x - A.x) - (A.x - p.x) * (B.y - A.y)) / len2;
      return Math.abs(s) * Math.sqrt(len2);
    }
  }, {
    key: "pointToLinePerpendicular",
    value: function pointToLinePerpendicular(p, A, B) {
      var len2 = (B.x - A.x) * (B.x - A.x) + (B.y - A.y) * (B.y - A.y);
      var s = ((A.y - p.y) * (B.x - A.x) - (A.x - p.x) * (B.y - A.y)) / len2;
      return Math.abs(s) * Math.sqrt(len2);
    }
  }, {
    key: "pointToSegmentString",
    value: function pointToSegmentString(p, line) {
      if (line.length === 0) throw new IllegalArgumentException('Line array must contain at least one vertex');
      var minDistance = p.distance(line[0]);
      for (var i = 0; i < line.length - 1; i++) {
        var dist = Distance.pointToSegment(p, line[i], line[i + 1]);
        if (dist < minDistance) {
          minDistance = dist;
        }
      }
      return minDistance;
    }
  }]);
}();
export { Distance as default };
Distance.constructor_ = function () {};